<template>
  <div class="role">
    <!-- 角色管理 -->
    <div class="organization-left">
      <div class="left-button">角色清单</div>
      <Button
        type="success"
        ghost
        class="role-left-btn fourSize"
        @click="addName()"
        >新增角色</Button
      >
      <div class="xiong-conten">
        <div
          class="xitong"
          @click="changexitongIndex(item, index)"
          :class="{ 'xitong-active': index == xitongIndex }"
          v-for="(item, index) in xitongLIst"
          :key="index"
        >
          <Tooltip
            v-show="item.roleName.length >= 8"
            :content="item.roleName"
            placement="top-start"
          >
            <span>{{ item.roleName }}</span>
          </Tooltip>
          <span v-show="item.roleName.length < 8">{{ item.roleName }}</span>
          <Button
            v-show="item.displayOrder !== 1"
            class="xitong-btn fourSizein"
            type="success"
            ghost
            @click="clearName(item, index)"
            >删除</Button
          >
          <Button
            v-show="item.displayOrder !== 1"
            class="xitong-btn fourSizein"
            type="success"
            ghost
            @click="changeName(item, index)"
            >修改</Button
          >
        </div>
        <!-- <div class="xitong" @click="changexitongIndex(item,index)" :class="{'xitong-active' : index==xitongIndex}" v-for="(item,index) in xitongLIst" :key="index">
                    <span>{{item.roleName}}</span>
                    <Button v-show="item.displayOrder!==1" class="xitong-btn" type="success" ghost @click="clearName(item,index)">删除</Button>
                    <Button v-show="item.displayOrder!==1" class="xitong-btn" type="success" ghost @click="changeName(item,index)">更名</Button>
                </div> -->
      </div>
    </div>
    <div class="organization-right">
      <div class="right-left">
        <div class="right-top-span right-top-spanone">数据权限</div>
        <div class="datasize-cont">
          <div
            class="datasize"
            @click="changedatasizeIndex(item, index)"
            v-for="(item, index) in datasizeList"
            :key="index"
          >
            {{ item.name }}
            <span :class="{ 'datasize-active': index == 0 }">
              <Icon type="ios-disc"
            /></span>
          </div>
        </div>
      </div>
      <div class="right-right">
        <div class="right-top-span right-top-spantwo">功能权限</div>
        <div class="check-cont-scroll">
          <div
            class="right-right-padding"
            v-for="(item, index) in checkList"
            :key="index"
          >
            <div class="check-Cont">
              <div class="datasize">
                <Checkbox
                  v-model="item.selected"
                  :disabled="isdisabled"
                  @on-change="
                    checkAllGroupChangetop(item, index, item.selected)
                  "
                ></Checkbox>
                <span class="xitong-span" @click="changeIcon(item)">{{
                  item.name
                }}</span>
              </div>
              <span @click="changeIcon(item)">
                <Icon
                  v-show="item.iconShow"
                  class="check-Cont-icon"
                  type="ios-arrow-up"
                />
                <Icon
                  v-show="!item.iconShow"
                  class="check-Cont-icon"
                  type="ios-arrow-down"
                />
              </span>
            </div>
            <div v-show="item.isshow" class="check-Cont-for">
              <div
                class="check-Cont"
                v-for="(itemItem, num) in item.data"
                :key="num"
              >
                <Checkbox
                  :disabled="isdisabled"
                  @on-change="checkAllGroupChange(item.id)"
                  v-model="itemItem.selected"
                  >{{ itemItem.name }}</Checkbox
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Alert class="alertTitle" v-show="alertTitleIshow" show-icon type="success"
      >操作成功</Alert
    >
    <Alert
      class="alertTitle"
      v-show="alertTitleIshow2"
      type="error"
      show-icon
      >{{ alertTitle }}</Alert
    >
    <!-- <Spin fix v-show="isiconfontshow">
      <span class="iconfont demo-spin-icon-load ivu-icon">&#xe71d;</span>
      <div>距离有些遥远，小简 正在努力中……</div>
    </Spin> -->
    <!-- 添加角色弹框 -->
    <Modal
      class="ivumodal"
      width="500"
      v-model="addNameIshhow"
      title="新增角色"
      footer-hide
    >
      <Form
        ref="addnameobj"
        :model="addnameobj"
        :label-width="170"
        :rules="addnamedates"
      >
        <FormItem label="角色名称：" prop="roleName" class="bumenModal-item">
          <Input
            v-model.trim="addnameobj.roleName"
            placeholder="请输入角色名称"
          />
        </FormItem>
      </Form>

      <div class="secondBumen-bottom">
        <Button
          class="btn"
          type="success"
          ghost
          @click="handleReset('addnameobj')"
          >取消</Button
        >
        <Button
          class="btn sure"
          type="success"
          ghost
          @click="handleSubmit('addnameobj')"
          >确定</Button
        >
      </div>
    </Modal>
    <!-- 更名弹窗 -->
    <Modal
      class="ivumodal"
      width="500"
      v-model="changeIshhow"
      title="修改角色"
      footer-hide
    >
      <div class="ivumodal-cont">
        <Form
          ref="formValidate"
          :model="formValidate"
          :label-width="170"
          :rules="ruleValidate"
        >
          <FormItem label="原名称：" prop="roleName" class="bumenModal-item">
            <Input v-model="formValidate.roleName" readonly />
          </FormItem>
          <FormItem label="现名称：" prop="newName" class="bumenModal-item">
            <Input v-model="formValidate.newName" placeholder="请输入现名称" />
          </FormItem>
        </Form>
      </div>
      <div class="secondBumen-bottom">
        <Button
          class="btn"
          type="success"
          ghost
          @click="formValidateReset('formValidate')"
          >取消</Button
        >
        <Button
          class="btn sure"
          type="success"
          ghost
          @click="formValidateSubmit('formValidate')"
          >确定</Button
        >
      </div>
    </Modal>
    <!-- 删除弹框 -->
    <Modal
      class="ivumodal"
      width="500"
      v-model="clearIshhow"
      title="删除确认"
      footer-hide
    >
      <div class="ivumodal-cont">
        {{ title }}
      </div>
      <div class="secondBumen-bottom">
        <Button class="btn" type="success" ghost @click="cancel()">取消</Button>
        <Button class="btn sure" type="success" ghost @click="ok()"
          >确定</Button
        >
      </div>
    </Modal>
  </div>
</template>
<script>
    import Vue from "vue";
    import {
        selectRole,
        updateRole,
        addRole,
        deleteRole,
        selectUserRoleByRoleId,
        getRoleAllInfo,
        addRolePermission
    } from "../servers/api";
    export default {
        name: "role",
        data() {
            return {
                alertTitle: "",
                alertTitleIshow2: false,
                alertTitleIshow: false,
                isiconfontshow: false, //控制请求接口动画显示
                social: ["1"],
                disabledGroup: "",
                xitongIndex: 0,
                isdisabled: false,
                xitongLIst: [], //左侧角色管理员列表
                datasizeactive: 0,
                datasizeList: [{
                    name: "系统管理员"
                }, {
                    name: "系统管理员"
                }], //数据权限列表
                checkAll: false,
                checkAllGroup: [], //选中得select数组
                iconShow: true,
                addnamedates: {
                    //添加角色校验
                    roleName: [{
                        required: true,
                        message: "请输入角色名称",
                        trigger: "blur"
                    }]
                },
                ruleValidate: {
                    roleName: [{
                        required: false,
                        message: "请输入原名称",
                        trigger: "blur"
                    }],
                    newName: [{
                        required: true,
                        message: "请输入现名称",
                        trigger: "blur"
                    }]
                }, //必填校验
                formValidate: {
                    //角色更名
                    roleName: "",
                    newName: ""
                },
                addnameobj: {
                    roleName: ""
                }, //添加角色
                addNameIshhow: false, //添加角色
                changeIshhow: false, //角色更名
                clearIshhow: false, //删除
                title: "当角色下有在职人员，不能执行删除", //确认对该角色执行删除操作？
                checkList: [], //系统设置列表
                deletitem: {},
                isDelet: false, //是否删除
                selectItemListL: [], //存储所有选中得select
                roleItem: {}
            };
        },
        created() {
            this.getselectRole();
            getRoleAllInfo();
        },
        methods: {
            changeIcon(item) {
                //控制显示隐藏
                for (let i = 0; i < this.checkList.length; i++) {
                    if (this.checkList[i].id == item.id) {
                        Vue.set(this.checkList[i], "isshow", !item.isshow);
                        this.checkList[i].iconShow = !this.checkList[i].iconShow;
                    }
                } //点击改变显示得isshoe属性
            },
            getRoleAllInfo(id) {
                //获取
                let params = {
                    roleId: id || ""
                };
                this.isiconfontshow = true;
                getRoleAllInfo(params).then(res => {
                    if (res.data.code == 1) {
                        this.isiconfontshow = false;
                        this.datasizeList = res.data.data.dataPermissionList || [];
                        this.checkList = res.data.data.permissionTreeJson; //功能权限总体数组
                        for (let i = 0; i < this.checkList.length; i++) {
                            //给功能权限得下拉框都加上属性
                            Vue.set(this.checkList[i], "isshow", true);
                            Vue.set(this.checkList[i], "social", []);
                            for (let j = 0; j < this.checkList[i].data.length; j++) {
                                if (this.checkList[i].data[j].selected) {
                                    this.checkList[i].social.push(this.checkList[i].data[j].id);
                                }
                            }
                        }
                        if (this.roleItem.roleId == 1) {
                            //点击的是系统管理员就不让设置权限
                            this.isdisabled = true;
                        } else {
                            this.isdisabled = false;
                        }
                    } else {
                        this.isiconfontshow = false;
                        this.alertTitle = res.data.msg;
                        this.alertTitleIshow2 = true;
                        setTimeout(() => {
                            this.alertTitleIshow2 = false;
                        }, 2000);
                    }
                });
            },
            checkAllGroupChange(id) {
                //点击select选项调用
                if (this.roleItem.roleId == 1) {
                    //点击的是系统管理员就不让设置权限
                    this.isdisabled = true;
                    return;
                } else {
                    this.isdisabled = false;
                }
                for (let i = 0; i < this.checkList.length; i++) {
                    if (this.checkList[i].id == id) {
                        this.checkList[i].selected = true;
                    }
                }
                this.addRolePermission();
            },
            addRolePermission() {
                // this.checkList = item;
                let list = [];
                let permissionNameList = [];
                for (let i = 0; i < this.checkList.length; i++) {
                    if (this.checkList[i].selected == true) {
                        list.push(this.checkList[i].id);
                        permissionNameList.push(this.checkList[i].name);
                        if (this.checkList[i].data.length > 0) {
                            for (let j = 0; j < this.checkList[i].data.length; j++) {
                                if (this.checkList[i].data[j].selected == true) {
                                    list.push(this.checkList[i].data[j].id);
                                    permissionNameList.push(this.checkList[i].data[j].name);
                                }
                            }
                        }
                    }
                }
                let params = {
                    roleId: this.roleItem.roleId || "",
                    roleName: this.roleItem.roleName || "",
                    permissionId: list.join(","),
                    permissionNameList: permissionNameList.join(",")
                };
                this.isiconfontshow = true;
                addRolePermission(params).then(res => {
                    if (res.data.code == 1) {
                        this.isiconfontshow = false;
                        this.alertTitleIshow = true;
                        setTimeout(() => {
                            this.alertTitleIshow = false;
                        }, 2000);
                        this.getRoleAllInfo(this.roleItem.roleId);
                    } else {
                        this.isiconfontshow = false;
                    }
                });
            },
            checkAllGroupChangetop(item, index, selected) {
                //全选 和取消全选
                if (this.roleItem.roleId == 1) {
                    //点击的是系统管理员就不让设置权限
                    this.isdisabled = true;
                    return;
                } else {
                    this.isdisabled = false;
                }
                for (let i = 0; i < item.data.length; i++) {
                    item.data[i].selected = selected;
                }
                this.addRolePermission();
            },
            getselectRole() {
                //获取角色清单接口
                this.isiconfontshow = true;
                selectRole({}).then(res => {
                    if (res.data.code == 1) {
                        this.isiconfontshow = false;
                        this.xitongLIst = res.data.data;
                        this.getRoleAllInfo(this.xitongLIst[0].roleId);
                        this.roleItem = this.xitongLIst[0];
                    } else {
                        this.isiconfontshow = false;
                    }
                });
            },
            changexitongIndex(item, index) {
                //切换角色清单
                this.xitongIndex = index;
                this.roleItem = item;
                this.getRoleAllInfo(item.roleId);
            },
            handleSubmit(name) {
                //添加角色 确定校验
                this.$refs[name].validate(valid => {
                    if (valid) {
                        // this.$Message.success('Success!');
                        let params = {
                            roleName: this.addnameobj.roleName
                        };
                        this.isiconfontshow = true;
                        addRole(params).then(res => {
                            //添加角色接口
                            if (res.data.code == 1) {
                                this.alertTitleIshow = true;
                                setTimeout(() => {
                                    this.alertTitleIshow = false;
                                }, 2000);
                                this.isiconfontshow = false;
                                this.addNameIshhow = false;
                                this.$refs[name].resetFields();
                                this.getselectRole();
                            } else {
                                this.isiconfontshow = false;
                                this.alertTitle = res.data.msg;
                                this.alertTitleIshow2 = true;
                                setTimeout(() => {
                                    this.alertTitleIshow2 = false;
                                }, 2000);
                            }
                        });
                    } else {
                        this.alertTitle = "请填写完整";
                        this.alertTitleIshow2 = true;
                        setTimeout(() => {
                            this.alertTitleIshow2 = false;
                        }, 2000);
                    }
                });
            },
            handleReset(name) {
                //添加角色取消
                this.$refs[name].resetFields();
                this.addNameIshhow = false;
            },
            formValidateSubmit(name) {
                //更名弹窗 确定
                this.$refs[name].validate(valid => {
                    if (valid) {
                        // 更名校验成功后调取接口
                        this.changeIshhow = false;
                        let params = {
                            roleId: this.formValidate.roleId,
                            newName: this.formValidate.newName
                        };
                        this.isiconfontshow = true;
                        updateRole(params).then(res => {
                            //
                            if (res.data.code == 1) {
                                // 接口成功后重新获取列表
                                this.isiconfontshow = false;
                                this.alertTitleIshow = true;
                                setTimeout(() => {
                                    this.alertTitleIshow = false;
                                }, 2000);
                                this.getselectRole();
                            } else {
                                this.isiconfontshow = false;
                                this.alertTitle = res.data.msg;
                                this.alertTitleIshow2 = true;
                                setTimeout(() => {
                                    this.alertTitleIshow2 = false;
                                }, 2000);
                            }
                        });
                    }
                });
            },
            formValidateReset(name) {
                //更名弹窗 取消
                this.$refs[name].resetFields();
                this.getselectRole();
                this.changeIshhow = false;
            },
            addName() {
                //添加角色
                this.addNameIshhow = true;
            },
            clearName(item, index) {
                //删除
                this.deletitem = item;
                let params = {
                    roleId: item.roleId
                };
                this.isiconfontshow = true;
                selectUserRoleByRoleId(params).then(res => {
                    if (res.data.code == 1) {
                        this.isiconfontshow = false;
                        this.isDelet = res.data.data.isUsed;
                        if (res.data.data.isUsed) {
                            this.title = "当角色下有在职人员，不能执行删除";
                        } else {
                            this.title = "确认对该角色执行删除操作？";
                        }
                        this.clearIshhow = true;
                    } else {
                        this.isiconfontshow = false;
                    }
                });
            },
            cancel() {
                this.clearIshhow = false;
            },
            ok(index) {
                if (this.isDelet) {
                    this.clearIshhow = false;
                } else {
                    //如果角色下没有人员 进行删除
                    let params = {
                        roleId: this.deletitem.roleId,
                        roleName: this.deletitem.roleName
                    };
                    this.isiconfontshow = true;
                    deleteRole(params).then(res => {
                        if (res.data.code == 1) {
                            this.isiconfontshow = false;
                            this.alertTitleIshow = true;
                            setTimeout(() => {
                                this.alertTitleIshow = false;
                            }, 2000);
                            this.clearIshhow = false;
                            this.xitongIndex = 0;
                            this.getselectRole();
                        } else {
                            this.isiconfontshow = false;
                            this.isiconfontshow = false;
                            this.alertTitle = res.data.msg;
                            this.alertTitleIshow2 = true;
                            setTimeout(() => {
                                this.alertTitleIshow2 = false;
                            }, 2000);
                        }
                    });
                }
            },
            changeName(item, index) {
                //更名

                this.formValidate = item;
                this.changeIshhow = true;
            },
            changedatasizeIndex(item, index) {
                this.datasizeactive = index;
            }
        }
    };
</script>
<style lang="scss" scoped="" type="text/css">
    @import "../css/conmmon.scss";
    @import "../font/iconfont.css";
    .xiong-conten {
        height: calc(100% - 40px);
        padding-right: 15px;
        padding-bottom: 30px;
        width: 100%;
        overflow: hidden;
        overflow-y: scroll;
        overflow-y: visible;
    }
    
    .check-cont-scroll {
        color: #7f7f7f;
        font-family: SimHei;
        height: calc(100% - 30px);
        overflow-y: scroll;
        overflow: hidden;
        overflow-y: visible;
    }
    
    .role {
        height: 100%;
        color: #7f7f7f;
        font-family: SimHei;
        .organization-left {
            padding: 15px;
            padding-right: 0;
            overflow: hidden;
            width: 280px;
            border-right: 1px solid #d7d7d7;
            height: calc(100% - 110px);
            position: absolute;
            font-size: 13px;
            color: #7f7f7f;
            .left-button {
                width: 250px;
                border: 1px solid #53cac3;
                height: 30px;
                text-align: center;
                line-height: 30px;
                border-top-left-radius: 11px;
                border-top-right-radius: 11px;
            }
            .role-left-btn {
                margin-top: 15px;
                margin-right: 5px;
                display: block;
                margin-left: 165px;
            }
            .xitong {
                cursor: pointer;
                margin-top: 15px;
                width: 240px;
                height: 40px;
                margin-left: 5px;
                background: #fff;
                border: 1px solid #53cac3;
                padding-left: 15px;
                padding-right: 5px;
                line-height: 40px;
                border-radius: 5px;
                span {
                    display: inline-block;
                    width: 98px;
                    overflow: hidden;
                    /*超出部分隐藏*/
                    white-space: nowrap;
                    /*不换行*/
                    text-overflow: ellipsis;
                    /*超出部分文字以...显示*/
                }
                .xitong-btn {
                    display: inline-block;
                    height: 30px;
                    line-height: 15px;
                    float: right;
                    margin: 4px 2px;
                }
            }
            .xitong-active {
                background: #53cac3;
                color: #fff;
                .xitong-btn {
                    background: #fff;
                }
            }
        }
        .organization-right {
            height: 100%;
            margin-left: 280px;
            padding: 15px;
            font-size: 13px;
            overflow: hidden;
            // overflow-y: scroll;
            // overflow-y:visible ;
            .right-left {
                position: absolute;
                height: 100%;
                width: 260px;
                .right-top-spanone {
                    line-height: 30px;
                    height: 30px;
                    width: 100%;
                    border: 1px solid #53cac3;
                    text-align: center;
                    border-top-left-radius: 10px;
                }
                .datasize-cont {
                    font-family: SimHei;
                    color: #7f7f7f;
                    padding-left: 15px;
                    width: 100%;
                    .datasize {
                        width: calc(100% - 15px);
                        padding-left: 15px;
                        border: 1px solid #53cac3;
                        margin-top: 15px;
                        height: 40px;
                        border-radius: 5px;
                        line-height: 40px;
                        span {
                            float: right;
                            margin-right: 15px;
                            color: #d7d7d7;
                        }
                        .datasize-active {
                            color: #53cac3;
                        }
                    }
                }
            }
            .right-right {
                height: 100%;
                margin-left: 260px;
                .right-top-spantwo {
                    height: 30px;
                    width: 100%;
                    border: 1px solid #53cac3;
                    border-left: none;
                    text-align: center;
                    line-height: 30px;
                    border-top-right-radius: 10px;
                }
                .right-right-padding {
                    padding-left: 15px;
                    padding-right: 15px;
                    width: 100%;
                    .check-Cont {
                        margin-top: 15px;
                        width: 100%;
                        height: 40px;
                        border: 1px solid #53cac3;
                        border-radius: 5px;
                        padding-left: 15px;
                        line-height: 40px;
                        position: relative;
                        .check-Cont-icon {
                            position: absolute;
                            top: 9px;
                            margin-right: 15px;
                            font-size: 20px;
                            right: 0;
                        }
                    }
                    .datasize {
                        width: 90%;
                        display: inline-block;
                    }
                    .xitong-span {
                        cursor: pointer;
                        padding-left: 15px;
                        display: inline-block;
                        width: 90%;
                    }
                    .check-Cont-for {
                        width: 100%;
                        padding-left: 15px;
                        .datasize {
                            padding-left: 15px;
                            width: 200px;
                            display: inline-block;
                        }
                    }
                }
            }
        }
    }
    
    .bumenModal-item {
        margin-bottom: 20px;
    }
</style>


// WEBPACK FOOTER //
// src/components/shezhi/role.vue